import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { Input } from "reakit";
import { Box, Button, Flex, Text } from "rebass";
import { Redirect, withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Circle } from "styled-spinkit";
import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import "./LoginForm.css";
import { PasswordForgetLink } from "../PasswordForget";
import { SSO_ENABLED_CLIENTS } from "../../constants/constants";

const StyledForm = styled.form`
  .auth-input {
    background-color: #121212;
    border-bottom: 3px solid #5f646b;
    color: #ffffff;
    border-radius: 0;
    font-size: 1.68rem;
    padding: 0;
    width: 26vw;
    height: 3.1rem;
    font-weight: 600;
  }

  .auth-input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #5f646b;
    opacity: 1;
    /* Firefox */
  }

  .auth-input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #5f646b;
  }

  .auth-input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #5f646b;
  }

  /* input.auth-input:not(:placeholder-shown), */
  input.auth-input:focus {
    border-bottom: 3px solid #ffffff;
  }

  input.auth-input.error {
    border-bottom: 3px solid #f95050;
  }

  .auth-btn {
    width: 100%;
    background-color: #317fb5;
    font-size: 1.68rem;
    height: 4rem;
  }

  .error-text {
    max-width: 26vw;
    text-align: center;
  }
  @media screen and (max-width: 1800px) {
    .auth-input {
      font-size: 1.5rem;
    }
    .auth-btn {
      font-size: 1.5rem;
      height: 3.5rem;
    }
  }
  @media screen and (max-width: 1420px) {
    .auth-input {
      font-size: 1.2rem;
      width: 30vw;
    }
    .auth-btn {
      font-size: 1.2rem;
      height: 3.1rem;
    }
  }
  @media screen and (max-width: 1024px) {
    .auth-input {
      font-size: 1.1rem;
      width: 32vw;
    }

    .auth-btn {
      font-size: 1.1rem;
    }
    .error-text {
      max-width: 18rem;
    }
  }
  @media screen and (max-width: 950px) {
    .auth-input {
      width: 35vw;
    }
  }
  @media screen and (max-width: 768px) {
    .auth-input {
      font-size: 1rem;
      min-width: 18rem;
    }

    .auth-btn {
      background-color: #317fb5;
      font-size: 1rem;
    }

    .error-text {
      max-width: 18rem;
    }
  }
`;

const INITIAL_STATE = {
  email: "",
  password: "",
  error: null,
  loggedIn: false,
  attempting: false,
  enabelSSO: false,
};

class LoginForm extends Component {
  state = { ...INITIAL_STATE, user: {} };

  componentDidMount() {
    // const {}
  }

  componentWillMount() {
    this.authListner();
  }

  authListner() {
    this.props.firebase.auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ attempting: true });
      } else {
        this.setState({ attempting: false });
      }
    });
  }

  onSubmit = (event) => {
    event.preventDefault();

    const { email, password, enabelSSO } = this.state;
    let stripped = email.trim();
    stripped = stripped.toLowerCase();
    //this.setState({attempting: true});
    if (!enabelSSO) {
      this.props.firebase
        .doSignInWithEmailAndPassword(stripped, password)
        .then((data) => {
          this.setState({ loggedIn: true, attempting: false });
          this.props.history.push(ROUTES.HOME);
        })
        .catch((error) => {
          this.setState({ error, attempting: false });
        });
    } else {
      this.props.firebase.doSignInWitSAML(stripped);
    }
  };

  onChange = (event) => {
    const stateName = event.target.name;
    const stateValue = event.target.value;
    let enabelSSO = false;
    if (stateName === "email") {
      const clientDomain = stateValue.replace(/.*@/, "").toLowerCase();
      if (SSO_ENABLED_CLIENTS.hasOwnProperty(clientDomain)) {
        enabelSSO = true;
      }
    }
    this.setState({ [stateName]: stateValue, enabelSSO });
  };

  render() {
    const {
      email,
      password,
      error,
      loggedIn,
      attempting,
      enabelSSO,
    } = this.state;
    const { profile, school } = this.props;

    const isInvalid = !enabelSSO
      ? password === "" || email === ""
      : email === "";

    if (loggedIn && school !== null) {
      return <Redirect to="/app/home" />;
    }

    if (profile === undefined || profile === null) {
      return (
        <Fragment>
          <StyledForm onSubmit={this.onSubmit}>
            <Flex justifyContent={"center"} width={1}>
              <Text className="error-text" color="#F95050">
                {error && <p>{error.message}</p>}
              </Text>
            </Flex>
            <Box></Box>
            <Box>
              <Input
                className={error ? "auth-input error" : "auth-input"}
                name="email"
                value={email}
                style={{ marginTop: "-1rem" }}
                onChange={this.onChange}
                type="text"
                placeholder="Email"
              />
            </Box>
            {!this.state.enabelSSO && (
              <Box mt={3}>
                <Input
                  name="password"
                  value={password}
                  className={error ? "auth-input error" : "auth-input"}
                  onChange={this.onChange}
                  type="password"
                  placeholder="Password"
                />
              </Box>
            )}
            <Flex justifyContent={"center"} width={1}>
              {attempting ? (
                <Circle color="white" />
              ) : (
                <Button
                  className="auth-btn"
                  style={{ marginTop: "2.8rem" }}
                  disabled={isInvalid}
                  type="submit"
                  variant={"main"}
                >
                  Log In
                </Button>
              )}
            </Flex>
          </StyledForm>
          {!enabelSSO && <PasswordForgetLink />}
        </Fragment>
      );
    } else {
      return <Redirect to={"/app/home"} />;
    }
  }
}

export default compose(
  withRouter,
  withFirebase
)(LoginForm);
